import React from "react";
import { KPI_KEYS } from "../utils/calendarUtils";

const MonthlyGoal = ({ kpis, onEditGoals }) => {
  return (
    <div className="monthly-goal-section">
      <h2>MONTHLY GOAL</h2>
      <div className="kpi-grid">
        {KPI_KEYS.map((kpi) => (
          <div key={kpi} className="kpi-item">
            <div className="kpi-label">{kpi}</div>
            <div className="kpi-value">{kpis[kpi]}</div>
          </div>
        ))}
      </div>
      <button className="edit-goal-btn" onClick={onEditGoals}>
        Edit
      </button>
    </div>
  );
};

export default MonthlyGoal;